var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import breakpoint from 'styled-components-breakpoint';
var ROW_PADDING_H = 2; // in rem

var TABLE_CELL_PADDING_H = 1.2; // in rem

var TABLE_CELL_INDENT = 2; // in rem
// Table

export var TableElement = styled.table.withConfig({
  displayName: "elements__TableElement",
  componentId: "sc-1y96j75-0"
})(["min-width:100%;border-spacing:0;position:relative;", ";"], breakpoint('xs', 'sm')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref) {
  var colsDef = _ref.colsDef;
  return colsDef && css(["width:", "%;table-layout:fixed;"], Math.max(100, colsDef.reduce(function (calculatedWidth, col) {
    return calculatedWidth + (col.isRowHeader ? 67 : 33);
  }, 0)));
}));
export var Row = styled.tr.withConfig({
  displayName: "elements__Row",
  componentId: "sc-1y96j75-1"
})(["position:relative;background:", ";& > *:first-child{padding-left:", ";}& > *:last-child{padding-right:", "rem;}", ";", ";", " ", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var depth = _ref3.depth;
  return "".concat(ROW_PADDING_H + depth * TABLE_CELL_INDENT, "rem");
}, ROW_PADDING_H, function (_ref4) {
  var isClickable = _ref4.isClickable;
  return isClickable && css(["cursor:pointer;"]);
}, function (_ref5) {
  var striped = _ref5.striped;
  return striped && css(["&:nth-child(even) > th,&:nth-child(even){background:", ";}"], function (_ref6) {
    var palette = _ref6.theme.palette;
    return palette.paleGrey;
  });
}, function (_ref7) {
  var isHoverable = _ref7.isHoverable;
  return isHoverable && css(["&:hover{& > th,& > td{background-color:", ";}}"], function (_ref8) {
    var palette = _ref8.theme.palette;
    return palette.veryLightGrey;
  });
}, function (_ref9) {
  var isUnfolded = _ref9.isUnfolded;
  return isUnfolded && css(["&:nth-child(1n) > th,&:nth-child(1n){background:", ";box-shadow:inset 3px 0px 0 0px ", ";}"], function (_ref10) {
    var palette = _ref10.theme.palette;
    return palette.veryLightGrey;
  }, function (_ref11) {
    var palette = _ref11.theme.palette;
    return palette.primary["default"];
  });
}); // Table Header

export var THeader = styled.thead.withConfig({
  displayName: "elements__THeader",
  componentId: "sc-1y96j75-2"
})(["font-size:", ";font-weight:", ";line-height:1.8rem;text-transform:uppercase;color:", ";"], function (_ref12) {
  var size = _ref12.theme.fonts.size;
  return size["default"];
}, function (_ref13) {
  var weight = _ref13.theme.fonts.weight;
  return weight.thick;
}, function (_ref14) {
  var palette = _ref14.theme.palette;
  return palette.darkGrey;
});
export var TableHeaderCell = styled.th.withConfig({
  displayName: "elements__TableHeaderCell",
  componentId: "sc-1y96j75-3"
})(["position:relative;height:4.4rem;padding:0 ", "rem;box-sizing:border-box;vertical-align:middle;border-bottom:1px solid ", ";background-color:", ";white-space:nowrap;text-align:", ";", " ", " ", " ", ";"], TABLE_CELL_PADDING_H, function (_ref15) {
  var palette = _ref15.theme.palette;
  return palette.veryLightBlue;
}, function (_ref16) {
  var palette = _ref16.theme.palette;
  return palette.white;
}, function (_ref17) {
  var align = _ref17.align;
  return align || 'left';
}, function (_ref18) {
  var isScrollable = _ref18.isScrollable;
  return isScrollable && css(["position:sticky;top:0;z-index:1;"]);
}, function (_ref19) {
  var isSortable = _ref19.isSortable;
  return isSortable && css(["cursor:pointer;"]);
}, function (_ref20) {
  var isRowHeader = _ref20.isRowHeader;
  return isRowHeader && css(["z-index:2;left:0;border-right:1px dotted ", ";"], function (_ref21) {
    var palette = _ref21.theme.palette;
    return palette.veryLightBlue;
  });
}, breakpoint('xs', 'sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 33%;\n    overflow:hidden;\n    text-overflow: ellipsis;\n\n    ", "\n  "])), function (_ref22) {
  var isRowHeader = _ref22.isRowHeader;
  return isRowHeader && css(["width:67%;"]);
}));
export var HeaderLabel = styled.span.withConfig({
  displayName: "elements__HeaderLabel",
  componentId: "sc-1y96j75-4"
})(["margin-right:0.8rem;user-select:none;"]); // Table Body

export var Body = styled.tbody.withConfig({
  displayName: "elements__Body",
  componentId: "sc-1y96j75-5"
})(["td,th{border-bottom:1px solid ", ";}tr:last-child td,tr:last-child th{border-bottom:0;}td,th{height:5.2rem;padding:0 1.2rem;white-space:nowrap;vertical-align:middle;box-sizing:border-box;font-feature-settings:'tnum';", ";", ";}"], function (_ref23) {
  var palette = _ref23.theme.palette;
  return palette.veryLightBlue;
}, function (_ref24) {
  var colsLength = _ref24.colsLength;
  return colsLength && css(["width:calc(100% / ", ");"], colsLength);
}, breakpoint('xs', 'sm')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: 33%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "]))));
export var RowHeader = styled.th.withConfig({
  displayName: "elements__RowHeader",
  componentId: "sc-1y96j75-6"
})(["max-width:30rem;min-width:20rem;white-space:nowrap;box-sizing:border-box;text-align:", ";text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding:0 1.2rem 0 2rem;background-color:", ";border-right:1px dotted ", ";", " ", " ", ";"], function (_ref25) {
  var align = _ref25.align;
  return align || 'left';
}, function (_ref26) {
  var palette = _ref26.theme.palette;
  return palette.white;
}, function (_ref27) {
  var palette = _ref27.theme.palette;
  return palette.veryLightBlue;
}, function (_ref28) {
  var weight = _ref28.theme.fonts.weight,
      hasChildren = _ref28.hasChildren;
  return hasChildren && css(["font-weight:", ";"], weight.thick);
}, function (_ref29) {
  var isScrollable = _ref29.isScrollable;
  return isScrollable && css(["position:sticky;left:0;"]);
}, breakpoint('xs', 'sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 67%;\n    min-width: 0;\n    max-width: none;\n    overflow:hidden;\n  "]))));
export var RowHeaderContent = styled.div.withConfig({
  displayName: "elements__RowHeaderContent",
  componentId: "sc-1y96j75-7"
})(["display:flex;align-items:center;"]);
export var TextEllipsis = styled.div.withConfig({
  displayName: "elements__TextEllipsis",
  componentId: "sc-1y96j75-8"
})(["display:inline-block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:100%;"]); // Table Footer

export var Footer = styled.tfoot.withConfig({
  displayName: "elements__Footer",
  componentId: "sc-1y96j75-9"
})(["position:sticky;bottom:0;text-transform:uppercase;th,td{font-feature-settings:'tnum';box-sizing:border-box;height:5.2rem;white-space:nowrap;padding:0 1.2rem;background-color:", ";color:", ";font-weight:", ";&:after{content:'';position:absolute;right:0;top:0;width:100%;border-top:1px solid ", ";box-sizing:border-box;}", "}td:last-of-type{padding:0 2rem 0 1.2rem;}th{padding:0 1.2rem 0 2rem;", "}", ""], function (_ref30) {
  var palette = _ref30.theme.palette;
  return palette.white;
}, function (_ref31) {
  var palette = _ref31.theme.palette;
  return palette.primary["default"];
}, function (_ref32) {
  var fonts = _ref32.theme.fonts;
  return fonts.weight.thick;
}, function (_ref33) {
  var palette = _ref33.theme.palette;
  return palette.veryLightBlue;
}, function (_ref34) {
  var isScrollable = _ref34.isScrollable;
  return isScrollable && css(["bottom:0;position:sticky;"]);
}, function (_ref35) {
  var isScrollable = _ref35.isScrollable;
  return isScrollable && css(["left:0;z-index:1;border-right:1px dotted ", ";"], function (_ref36) {
    var palette = _ref36.theme.palette;
    return palette.veryLightBlue;
  });
}, function (_ref37) {
  var isHoverable = _ref37.isHoverable;
  return isHoverable && css(["tr:hover{& > th,& > td{background-color:", ";}}"], function (_ref38) {
    var palette = _ref38.theme.palette;
    return palette.veryLightGrey;
  });
}); // Table Container

export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "sc-1y96j75-10"
})(["background:", ";height:", ";", " width:100%;position:relative;"], function (_ref39) {
  var palette = _ref39.theme.palette;
  return palette.white;
}, function (_ref40) {
  var containerHeight = _ref40.containerHeight;
  return containerHeight;
}, function (_ref41) {
  var isScrollable = _ref41.isScrollable;
  return isScrollable && css(["overflow:scroll;"]);
}); // Shadow Container

export var ShadowContainer = styled.div.withConfig({
  displayName: "elements__ShadowContainer",
  componentId: "sc-1y96j75-11"
})(["pointer-events:none;position:absolute;top:0;bottom:0;right:0;left:", ";z-index:10;box-shadow:", " background-repeat:no-repeat;background-size:10px 100%;"], function (_ref42) {
  var firstCellWidth = _ref42.firstCellWidth;
  return firstCellWidth && "".concat(firstCellWidth, "px");
}, function (_ref43) {
  var side = _ref43.side,
      palette = _ref43.theme.palette;
  var shadowColor = transparentize(0.9, palette.black);

  if (side === 'left') {
    return "inset -8px 0 6px -6px ".concat(shadowColor, ";");
  } else if (side === 'right') {
    return "inset 8px 0 6px -6px ".concat(shadowColor, ";");
  } else if (side === 'both') {
    return "inset -8px 0 6px -6px ".concat(shadowColor, ", inset 8px 0 6px -6px ").concat(shadowColor, ";");
  }

  return null;
}); // Shadow Container

export var ShadowWrapped = styled.div.withConfig({
  displayName: "elements__ShadowWrapped",
  componentId: "sc-1y96j75-12"
})(["position:relative;height:", ";"], function (_ref44) {
  var containerHeight = _ref44.containerHeight;
  return containerHeight;
});